import { useModal } from "@/Contexts";
import { EyeIcon } from "@/Icons/v2/Eye";
import type { LibraryFile } from "@/pages/library_v2/components/filesView/types";
import {
  downloadFile,
  getIsPreviewable,
} from "@/pages/library_v2/components/filesView/utils";
import { useTrans } from "@/translations";

import { useMemo } from "react";

import { ActionButton } from "./actions/actionButton";
import { PreviewFileModal } from "./previewFileModal";

type Props = {
  file: LibraryFile;
  tooltipPlacement: "top" | "bottom";
};

export const PreviewFile: React.FC<Props> = ({ file, tooltipPlacement }) => {
  const { t } = useTrans();
  const { showModal } = useModal();

  const isPreviewableFile = useMemo(() => getIsPreviewable(file), [file]);

  if (!isPreviewableFile) {
    return <></>;
  }

  return (
    <ActionButton
      icon={<EyeIcon size={20} color="#1D1C1C" />}
      label={t("libraryPage:fileListActionPreview")}
      align="left"
      placement={tooltipPlacement}
      onClick={() =>
        showModal(<PreviewFileModal file={file} onDownload={downloadFile} />)
      }
    />
  );
};
